import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { Row, Col, Tag, Tooltip, message } from "antd";
import { TableItem } from "../../../Components/Items";
import BotonesReporte from "./BotonesReporte";
import { colorServidor } from "./utilsPerformance";

moment.locale("es");

const TARJETA = {
    backgroundColor: "white",
    padding: 15,
    borderRadius: 5,
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
};

// Mismos veredictos que Utils/atribucionSaturacion.utils.js del backend.
const VEREDICTOS = {
    unico: { texto: "Causante único", color: "red" },
    probable: { texto: "Sospechoso probable", color: "volcano" },
    ambiguo: { texto: "Ambiguo", color: "orange" },
    background: { texto: "Background", color: "purple" },
    "lentos-por-si-mismos": { texto: "Lentos por sí mismos", color: "blue" },
};

/**
 * Cada correo de saturación que mandó el monitor (se guardan desde que existe esta
 * pestaña, 90 días). Desde aquí se regenera el mismo reporte que venía adjunto.
 */
class Alertas extends Component {
    state = {
        cargado: false,
        loading: false,
        alertas: [],
        total: 0,
    };

    componentDidMount() {
        if (this.props.activo) this.consultar();
    }

    componentDidUpdate(prevProps) {
        const cambioRango = prevProps.rango !== this.props.rango;
        const pidieronRefrescar = prevProps.refrescarNonce !== this.props.refrescarNonce;
        const seActivo = !prevProps.activo && this.props.activo;

        if (this.props.activo && (cambioRango || pidieronRefrescar)) {
            this.consultar();
            return;
        }
        if (seActivo && (!this.state.cargado || cambioRango || pidieronRefrescar)) {
            this.consultar();
        }
    }

    consultar = () => {
        const [desde, hasta] = this.props.rango || [];
        this.setState({ cargado: true, loading: true });
        axios
            .post(
                "performance/alertas/listar",
                {
                    desde: desde ? desde.toISOString() : undefined,
                    hasta: hasta ? hasta.toISOString() : undefined,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    this.setState({ alertas: res.data.data || [], total: res.data.total || 0 });
                } else {
                    message.error(res.data.message || "Error al consultar las alertas");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al consultar las alertas");
            });
    };

    render() {
        const { alertas, total, loading } = this.state;

        const columnas = [
            {
                title: "Fecha",
                dataIndex: "instante",
                key: "instante",
                width: 160,
                render: (v) => (v ? moment(v).format("DD/MM/YYYY HH:mm:ss") : "-"),
            },
            {
                title: "Servidor",
                dataIndex: "servidor",
                key: "servidor",
                width: 160,
                render: (v) => <Tag color={colorServidor(v)}>{v}</Tag>,
            },
            {
                title: "Veredicto",
                dataIndex: "veredicto",
                key: "veredicto",
                width: 170,
                render: (v) => {
                    const info = VEREDICTOS[v];
                    return info ? <Tag color={info.color}>{info.texto}</Tag> : <span style={{ color: "#999" }}>—</span>;
                },
            },
            {
                title: "Resumen",
                dataIndex: "resumen",
                key: "resumen",
                render: (v) => (
                    <Tooltip title={v}>
                        <span style={{ fontSize: 12 }}>{v || "—"}</span>
                    </Tooltip>
                ),
            },
            {
                title: "Lentos",
                dataIndex: "totalEventos",
                key: "totalEventos",
                width: 80,
                align: "right",
            },
            {
                title: "Encolados",
                dataIndex: "encolados",
                key: "encolados",
                width: 95,
                align: "right",
                render: (v) => (
                    <span style={{ color: v > 0 ? "#cf1322" : "#333", fontWeight: v > 0 ? "bold" : "normal" }}>
                        {v ?? "—"}
                    </span>
                ),
            },
            {
                title: "En vuelo",
                dataIndex: "enVuelo",
                key: "enVuelo",
                width: 100,
                align: "right",
                render: (v, r) => (
                    <span>
                        {v ?? "—"}
                        {r.zombis ? <span style={{ color: "#fa8c16" }}> (+{r.zombis}z)</span> : null}
                    </span>
                ),
            },
            {
                title: "Reporte",
                key: "reporte",
                width: 300,
                render: (v, r) => (
                    <BotonesReporte
                        endpoint="performance/alertas/reporte"
                        cuerpo={{ alertaId: r._id }}
                        headersToken={this.props.headersToken}
                    />
                ),
            },
        ];

        return (
            <div style={{ ...TARJETA, marginBottom: 10 }}>
                <Row align="middle" justify="space-between" style={{ marginBottom: 10 }}>
                    <Col>
                        <h3 style={{ margin: 0 }}>Alertas de saturación enviadas por correo</h3>
                        <span style={{ fontSize: 12, color: "#888" }}>
                            El mismo reporte que venía adjunto al correo, en PDF o en texto para pegarlo en
                            Claude. Se guardan desde que se instaló esta pestaña.
                        </span>
                    </Col>
                    <Col>
                        <span style={{ fontSize: 12, color: "#888" }}>
                            {total > alertas.length
                                ? `Mostrando las ${alertas.length} más recientes de ${total}`
                                : `${total} alertas en el rango`}
                        </span>
                    </Col>
                </Row>
                <TableItem
                    loading={loading}
                    dataSource={alertas}
                    columns={columnas}
                    size="small"
                    rowKey={(r) => r._id}
                    defaultPageSize={20}
                />
            </div>
        );
    }
}

export default Alertas;
